<template>
    <brick-settings-popup
        :resources="{
            deletePromptTitle: resource('JourneyBuilder_JourneySettings_Delete_Title'),
            deletePromptBody: resource('JourneyBuilder_JourneySettings_Delete_Body'),
            brickTitle: `${resource('JourneyComposer_BrickSettingsJourney_Title')} ${resource('JourneyComposer_BrickSettingsBase_Title')}`
        }"
        :brick="brick"
        :name.sync="newName"

        @save="saveSettings()"
        @delete="$emit('delete')"
        @hidden="$emit('hidden')"
    >
        <settings-item icon="fas fa-route" :label="resource('JourneyBuilder_Shared_Journey')">
            <template #input="{id}">
                <journey-dropdown 
                    :id="id"
                    :extra-journeys="externalJourneys"
                    :disabled="!canWrite"
                    
                    v-model="journeyIdModel"
                />
            </template>
        </settings-item>
    </brick-settings-popup>
</template>

<script>
    import brickTypes from '@modules/JourneyBuilder/Bricks/brick-types';
    import {brickDefinitions} from "@modules/JourneyBuilder/Bricks/brick-definitions";
    
    import BrickSettingsPopup from '../BrickSettingsPopup';
    import brickSettings from '../Mixins/brick-settings';
    import JourneyDropdown from "@modules/JourneyBuilder/Components/Elements/JourneyDropdown";
    
    export default {
        name: 'journey-brick-settings-journey',
        components: {
            JourneyDropdown,
            BrickSettingsPopup
        },
        mixins: [brickSettings],
        created() {
            //Make journeyId reactive
            this.$set(this.settings, 'journeyId', this.settings.journeyId || undefined);
        },
        computed: {
            journeyIdModel: {
                get(){
                    return this.settings.journeyId;
                },
                set(value){
                    this.settings.journeyId = value;
                }
            },
            externalJourneys(){
                if(!this.settings.journeyId){
                    return [];
                }

                //Temporary workaround until we implement a better solution
                //if for example our current journey becomes unavailable to moving division
                //we don't want to completely break the brick when 'edit' is clicked
                return [{
                    id: this.settings.journeyId,
                    name: this.name
                }];
            }
        },
        watch: {
            'selectedJourney.label'(newLabel, oldLabel) {
                const defaultLabel = brickDefinitions[brickTypes.journey].displayName;
                
                //newName should change along with selected journey when name equals old journey name
                //or has not been changed (= default)
                if(this.newName === oldLabel || this.newName === defaultLabel){
                    this.newName = newLabel || defaultLabel;
                }
            }
        }
    };
</script>
